var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-list users-list-checkers"},[_c('list-users',{attrs:{"users":_vm.allCheckers,"type":"checkers"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }